import { enableProdMode, importProvidersFrom } from '@angular/core';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ROUTER_CONFIGURATION } from '@angular/router';
import {
  NgbAccordionModule,
  NgbActiveModal,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbDatepickerI18nDefault,
} from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { CartAdapter, CartEntryAdapter } from '@spartacus/cart/base/core';
import {
  AuthGuard,
  AuthRedirectService,
  AuthStatePersistenceService,
  ConfigModule,
  CxDatePipe,
  HttpErrorHandler,
  provideConfig,
} from '@spartacus/core';
import { OrderHistoryAdapter } from '@spartacus/order/core';
import { AppRoutingModule, OnNavigateConfig, PageSlotModule, SpinnerModule } from '@spartacus/storefront';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { AppComponent } from './app/app.component';
import { KnBrI18nModule } from './app/common/i18n/i18n.module';
import { CustomerIdMapHttpInterceptor } from './app/common/interceptors/customer-id-map-http-config.interceptor';
import { KnBrBackButtonModule } from './app/common/kn-br-back-button/kn-br-back-button.module';
import { KnBrBannerModule } from './app/common/kn-br-banner/kn-br-banner.module';
import { KnBrBreadCrumbModule } from './app/common/kn-br-bread-crumb/kn-br-bread-crumb.module';
import { KnBrConfirmDialogModule } from './app/common/kn-br-confirm-dialog/kn-br-confirm-dialog.module';
import { KnBrFooterModule } from './app/common/kn-br-footer/kn-br-footer.module';
import { KnBrLayoutConfigModule } from './app/common/kn-br-layout-config/kn-br-layout-config.module';
import { KnBrMessageDialogModule } from './app/common/kn-br-message-dialog/kn-br-message-dialog.module';
import { KnBrMetaResolverModule } from './app/common/kn-br-meta-resolvers/kn-br-meta-resolver.module';
import { KnBrMiniCartModule } from './app/common/kn-br-mini-cart/kn-br-mini-cart.module';
import { KnBrOutletModule } from './app/common/kn-br-outlet/kn-br-outlet.module';
import { KnBrWhatsNewModule } from './app/common/kn-br-whats-new/kn-br-whats-new.module';
import { knBrDefaultAsmLayoutConfig } from './app/kn-br-asm/kn-br-asm-layout-config';
import { KnBrAsmModule } from './app/kn-br-asm/kn-br-asm.module';
import { KnBrCaseCreateModule } from './app/kn-br-case-create/kn-br-case-create.module';
import { KnBrCaseDetailModule } from './app/kn-br-case-detail/kn-br-case-detail.module';
import { KnBrCaseListingModule } from './app/kn-br-case-listing/kn-br-case-listing.module';
import { KnBrCheckoutModule } from './app/kn-br-checkout/kn-br-checkout.module';
import { KnBrContactModule } from './app/kn-br-contact/kn-br-contact.module';
import { KnBrCommonAddressModule } from './app/kn-br-customer360/kn-br-common-address/kn-br-common-address.module';
import { KnBrCustomer360Module } from './app/kn-br-customer360/kn-br-customer360.module';
import { KnBrDraftOrderModule } from './app/kn-br-draft-order/kn-br-draft-order.module';
import { FindMyContactModule } from './app/kn-br-find-my-contact/find-my-contact.module';
import { KnBrForgotPasswordModule } from './app/kn-br-forgot-password/kn-br-forgot-password.module';
import { KnBrHomeModule } from './app/kn-br-home/kn-br-home.module';
import { KnBrLoginApproverModule } from './app/kn-br-login-approver/kn-br-login-approver.module';
import { KnBrLoginFormModule } from './app/kn-br-login-form/kn-br-login-form.module';
import { KnBrLogoutModule } from './app/kn-br-logout/kn-br-logout.module';
import { KnBrNacModule } from './app/kn-br-nac/kn-br-nac.module';
import { KnBrCategoryNavigationModule } from './app/kn-br-navigation/kn-br-category-navigation/kn-br-category-navigation.module';
import { KnBrNavigationModule } from './app/kn-br-navigation/kn-br-navigation.module';
import { KnBrOrderConfirmationModule } from './app/kn-br-order-confirmation/kn-br-order-confirmation.module';
import { KnBrOrderToolsModule } from './app/kn-br-order-tools/kn-br-order-tools.module';
import { KnBrProductModule } from './app/kn-br-product/kn-br-product.module';
import { KnBrProfileModule } from './app/kn-br-profile/kn-br-profile.module';
import { KnBrQuickLinksModule } from './app/kn-br-quick-links/kn-br-quick-links.module';
import { KnBrQuoteModule } from './app/kn-br-quote/kn-br-quote.module';
import { KnBrResetPasswordModule } from './app/kn-br-reset-password/kn-br-reset-password.module';
import { KnBrCustomSectionModule } from './app/kn-br-sales-landing/kn-br-custom-section/kn-br-custom-section.module';
import { KnBrSalesLandingModule } from './app/kn-br-sales-landing/kn-br-sales-landing.module';
import { KnBrShippingListModule } from './app/kn-br-shipping/kn-br-shipping-list/kn-br-shipping-list.module';
import { KnBrShippingModule } from './app/kn-br-shipping/kn-br-shipping.module';
import { KnBrSpotlightModule } from './app/kn-br-spotlight/kn-br-spotlight.module';
import { KnbrSsoModule } from './app/knbr-sso/knbr-sso.module';
import { KnBrAuthRedirectService } from './app/services/kn-br-auth-redirect.service';
import { KnBrAuthStatePersistenceService } from './app/services/kn-br-auth-state-persistence.service';
import { KnBrCsAgentAuthService } from './app/services/kn-br-csagent-auth.service';
import { KnBrIgnoreInvalidCodeHttpErrorHandler } from './app/services/kn-br-ignore-invalid-code-http-error-handler';
import { KnBrOccCartEntryAdapter } from './app/services/kn-br-occ-cart-entry.adapter';
import { KnBrOccCartAdapter } from './app/services/kn-br-occ-cart.adapter';
import { KnBrOccUserOrderAdapter } from './app/services/kn-br-occ-user-order.adapter';
import { KnBrAuthGuard } from './app/shared/guards/kn-br-auth.guard';
import { MomentDateFormatter } from './app/shared/moment-date.formatter';
import { SpartacusModule } from './app/spartacus/spartacus.module';
import { KnBrAddressStateModule } from './app/store/kn-br-address/kn-br-address.state.module';
import { KnBrCartContextStateModule } from './app/store/kn-br-cart-context/kn-br-cart-context.module';
import { KnBrCartStateModule } from './app/store/kn-br-cart/kn-br-cart-state.module';
import { KnBrCustomerContextStateModule } from './app/store/kn-br-customer-context/kn-br-customer-context.module';
import { KnBrCustomerStateModule } from './app/store/kn-br-customer/kn-br-customer.state.module';
import { KnBrDraftOrdersCommentsStateModule } from './app/store/kn-br-draft-order-comments/kn-br-draft-orders-comments.state.module';
import { KnBrDraftOrdersStateModule } from './app/store/kn-br-draft-orders/kn-br-draft-orders.state.module';
import { KnBrFactSheetStateModule } from './app/store/kn-br-fact-sheet/kn-br-fact-sheet.state.module';
import { KnBrInvoiceStateModule } from './app/store/kn-br-invoice/kn-br-invoice.state.module';
import { KnBrOrderHistoryStateModule } from './app/store/kn-br-order-history/kn-br-order-history.state.module';
import { KnBrOrderReturnStateModule } from './app/store/kn-br-order-return/kn-br-order-return.state.module';
import { KnBrQuoteContextStateModule } from './app/store/kn-br-quote-context/kn-br-quote-context.module';
import { KnBrQuoteEntryStateModule } from './app/store/kn-br-quote-entry/kn-br-quote-entry.module';
import { KnBrQuoteReferenceStateModule } from './app/store/kn-br-quote-reference/kn-br-quote-reference.module';
import { KnBrQuotesCommentsStateModule } from './app/store/kn-br-quotes-comments/kn-br-quotes-comments.state.module';
import { KnBrQuotesStateModule } from './app/store/kn-br-quotes/kn-br-quotes.state.module';
import { KnBrSpinnerStateModule } from './app/store/kn-br-spinner/kn-br-spinner-state.module';
import { environment } from './environments/environment';
import { KnbrNewAuth0SsoModule } from './app/knbr-new-auth0-sso/knbr-new-auth0-sso.module';
import { KnBrShipmentArrivalsModule } from './app/kn-br-shipment-arrivals/kn-br-shipment-arrivals.module';
import { KnBrTwoLetterWeekdayDatepickerI18nService } from './app/shared/kn-br-two-letter-weekday-datepicker-i18n.service';
import { KnBrSalesCartModule } from './app/kn-br-sales-cart/kn-br-sales-cart.module';
import { KnBrBrandBannerModule } from './app/common/kn-br-brand-banner/kn-br-brand-banner.module';
import { knBrDraftOrderEndpointsConfig } from './app/kn-br-draft-order/kn-br-draft-order-endpoints.config';
import { KnBrSalesCheckoutModule } from './app/kn-br-sales-checkout/kn-br-sales-checkout.module';
import { KnbrSalesOrderConfirmationModule } from './app/knbr-sales-order-confirmation/knbr-sales-order-confirmation.module';
import { KnbrRequestQuoteConfirmationModule } from './app/knbr-request-quote-confirmation/knbr-request-quote-confirmation.module';
import { KnBrRequestQuoteModule } from './app/kn-br-request-quote/kn-br-request-quote.module';
import { KnBrOrderConfirmationLedgerModule } from './app/kn-br-order-confirmation-ledger/kn-br-order-confirmation-ledger.module';
import { KnBrRequestQuoteListingModule } from './app/kn-br-request-quote-listing/kn-br-request-quote-listing.module';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      KnBrAsmModule,
      ConfigModule.withConfig(knBrDefaultAsmLayoutConfig),
      StoreModule.forRoot({}),
      EffectsModule.forRoot([]),
      SpartacusModule,
      KnBrOutletModule,
      PageSlotModule,
      KnBrBannerModule,
      KnBrLoginFormModule,
      KnBrForgotPasswordModule,
      KnBrFooterModule,
      KnBrBreadCrumbModule,
      // KnBrParagraphModule,
      KnBrLayoutConfigModule,
      KnBrHomeModule,
      // SidebarModule.forRoot(),
      MatSidenavModule,
      KnBrNavigationModule,
      KnBrI18nModule,
      KnBrCategoryNavigationModule,
      KnBrProductModule,
      //KnBrDraftOrderModule,
      KnBrQuoteModule,
      //KnBrMiniCartModule,
      //KnBrCheckoutModule,
      KnBrConfirmDialogModule,
      KnBrCartStateModule,
      StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production, connectInZone: true }),
      KnBrCustomerStateModule,
      KnBrCustomerContextStateModule,
      KnBrDraftOrdersStateModule,
      KnBrQuotesStateModule,
      KnBrCartContextStateModule,
      KnBrQuoteContextStateModule,
      KnBrQuoteEntryStateModule,
      KnBrResetPasswordModule,
      KnBrQuotesCommentsStateModule,
      KnBrDraftOrdersCommentsStateModule,
      KnBrQuoteReferenceStateModule,
      KnBrLoginApproverModule,
      KnBrMetaResolverModule,
      NgxDocViewerModule,
      KnBrCustomer360Module,
      KnBrInvoiceStateModule,
      KnBrOrderHistoryStateModule,
      KnBrOrderReturnStateModule,
      //KnBrOrderToolsModule,
      KnBrAddressStateModule,
      KnBrNacModule,
      KnBrQuickLinksModule,
      KnBrBackButtonModule,
      KnBrOrderConfirmationModule,
      KnBrFactSheetStateModule,
      KnbrSsoModule,
      KnbrNewAuth0SsoModule,
      KnBrShipmentArrivalsModule,
      SpinnerModule,
      KnBrCaseCreateModule,
      KnBrCaseListingModule,
      KnBrCaseDetailModule,
      ConfigModule.withConfig({
        pagination: {
          addPrevious: true,
          addNext: true,
          addDots: false,
        },
      }),
      KnBrSpinnerStateModule,
      KnBrMessageDialogModule,
      KnBrContactModule,
      KnBrLogoutModule,
      KnBrCommonAddressModule,
      KnBrProfileModule,
      KnBrShippingModule,
      KnBrShippingListModule,
      NgbAccordionModule,
      KnBrSalesLandingModule,
      KnBrWhatsNewModule,
      KnBrSpotlightModule,
      KnBrCustomSectionModule,
      FindMyContactModule,
      KnBrSalesCartModule,
      KnBrBrandBannerModule,
      ConfigModule.withConfig(knBrDraftOrderEndpointsConfig),
      KnBrSalesCheckoutModule,
      KnbrSalesOrderConfirmationModule,
      KnbrRequestQuoteConfirmationModule,
      KnBrRequestQuoteModule,
      KnBrOrderConfirmationLedgerModule,
      KnBrRequestQuoteListingModule
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: CustomerIdMapHttpInterceptor,
      multi: true,
    },
    {
      provide: HttpErrorHandler,
      useClass: KnBrIgnoreInvalidCodeHttpErrorHandler,
      multi: true,
    },
    {
      provide: CartAdapter,
      useClass: KnBrOccCartAdapter,
    },
    {
      provide: CartEntryAdapter,
      useClass: KnBrOccCartEntryAdapter,
    },
    {
      provide: OrderHistoryAdapter,
      useClass: KnBrOccUserOrderAdapter,
    },
    {
      provide: AuthRedirectService,
      useClass: KnBrAuthRedirectService,
    },
    {
      provide: CsAgentAuthService,
      useClass: KnBrCsAgentAuthService,
    },
    {
      provide: AuthStatePersistenceService,
      useClass: KnBrAuthStatePersistenceService,
    },
    {
      provide: AuthGuard,
      useClass: KnBrAuthGuard,
    },
    {
      provide: NgbDatepickerI18n,
      useClass: KnBrTwoLetterWeekdayDatepickerI18nService,
    },
    { provide: NgbDateParserFormatter, useClass: MomentDateFormatter },
    provideConfig(<OnNavigateConfig>{
      enableResetViewOnNavigate: {
        active: false,
      },
    }),
    {
      provide: ROUTER_CONFIGURATION,
      useValue: { scrollPositionRestoration: 'disabled' },
    },
    CxDatePipe,
    NgbActiveModal,
    provideHttpClient(withInterceptorsFromDi()),
    provideConfig({
      features: {
        a11yImproveContrast: false,
      },
    }),
  ],
}).catch((err) => console.error(err));
